import { FC } from 'react';
import styled from 'styled-components';
import { borderRadius, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Wrapper = styled.div`
  border: ${spacing.single} solid ${colors.borderPrimary};
  border-radius: ${borderRadius.lg};
  display: grid;
  grid-template-areas: 'header' 'banner' 'body' 'footer';
  grid-template-rows: 
  ${`${pxToRem(72)}  
  auto 
  fit-content(${pxToRem(200)}) 
  fit-content(${pxToRem(52)})`};
`;

type ListProps = {
  name?: string;
};

export const List: FC<React.PropsWithChildren<ListProps>> = ({ children, name }) => (
  <Wrapper role="list" aria-label={name}>
    {children}
  </Wrapper>
);
